<template>
   <div>
      <navbar-component />
      <main class="profile-page">
         <!-- Background section -->
         <section class="relative block h-500-px">
            <div
               class="absolute top-0 w-full h-full bg-center bg-cover"
               style="
                  background-image: url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80');
               "
            >
               <span
                  id="blackOverlay"
                  class="w-full h-full absolute opacity-50 bg-black"
               ></span>
            </div>
            <div
               class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
               style="transform: translateZ(0)"
            >
               <svg
                  class="absolute bottom-0 overflow-hidden"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
               >
                  <polygon
                     class="text-blueGray-200 fill-current"
                     points="2560 0 2560 100 0 100"
                  ></polygon>
               </svg>
            </div>
         </section>
         <!-- Card section -->
         <section class="relative py-16 bg-blueGray-200">
            <div class="container mx-auto px-4">
               <div
                  class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64"
               >
                  <div class="px-6">
                     <div class="text-center mt-12 mb-8">
                        <h2 class="text-4xl font-bold text-blueGray-700 mb-2">
                           About Advanced Measurements Inc.
                        </h2>
                        <div class="flex justify-center mb-4">
                           <span
                              class="inline-block w-24 h-1 rounded bg-emerald-400"
                           ></span>
                        </div>
                     </div>
                     <div class="max-w-2xl mx-auto text-left">
                        <div class="mb-8">
                           <h3
                              class="text-2xl font-semibold text-blue-800 mb-4"
                           >
                              Company Overview
                           </h3>
                           <p class="text-lg text-blueGray-800 mb-4">
                              Advanced Measurements, Inc., was established in
                              1989 in Calgary, Alberta, Canada. With over 30+
                              years of controls and automation experience, AMI
                              has primarily focused on mobile oil field service
                              equipment since 2000. We hold the longest standing
                              relationship with National Instruments (NI)
                              utilizing their real-time controllers and
                              accumulating over 75,000 software engineer
                              man-hours in the platform.
                           </p>
                           <p class="text-lg text-blueGray-800 mb-4">
                              Our service and support team has deployed over
                              2,500 control systems on three continents. With
                              customer support available 24/7, customers trust
                              our dedication to their success in the field.
                           </p>
                           <p class="text-lg text-blueGray-800 mb-4">
                              AMI is committed to implementing innovative
                              practices that deliver reliable products to our
                              customers.
                           </p>
                        </div>
                        <div class="mb-8 text-center">
                           <h4 class="text-lg font-semibold text-blue-800 mb-2">
                              Contact Information
                           </h4>
                           <ul
                              class="text-blueGray-700 mb-2 inline-block text-left"
                           >
                              <li class="mb-1">
                                 <strong>Location:</strong> Calgary, Alberta,
                                 Canada
                              </li>
                              <li class="mb-1">
                                 <strong>Phone:</strong> (403) 463-1911
                              </li>
                              <li class="mb-1">
                                 <strong>Contact:</strong>
                                 <a
                                    href="/#contact"
                                    @click.prevent="scrollToContact"
                                    class="text-emerald-600 underline ml-2 cursor-pointer"
                                    >Contact form</a
                                 >
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </main>
      <footer-component />
   </div>
</template>

<script>
import NavbarComponent from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

export default {
   name: "About",
   components: {
      NavbarComponent,
      FooterComponent,
   },
   methods: {
      scrollToContact() {
         // First navigate to home page
         this.$router.push("/").then(() => {
            // Wait for the next tick to ensure the page has loaded
            this.$nextTick(() => {
               // Find the contact section and scroll to it
               const contactSection = document.getElementById("contact");
               if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
               }
            });
         });
      },
   },
};
</script> 